import React, { Fragment, useContext } from 'react';
import { useTheme  } from '@emotion/react';
import PropTypes from 'prop-types';
import { StyleSheet, css } from 'aphrodite/no-important';
import { ThemeContext } from '../theme';

const propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  selected: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  onClick: PropTypes.func
};

const defaultProps = {
  selected: false,
  style: {},
  className: ''
};

const NavItem = React.forwardRef(({ navigate, ...props }, ref) => {
  const { selected, className, style } = props;
  const context = useContext(ThemeContext);
  const theme = useTheme();
  let navbar;
  if (theme && theme.navbar) {
    navbar = theme.navbar;
  } else {
    navbar = context.theme.navbar;
  }
  const {
    navbarHeight,
    navItemBackground,
    navItemColor,
    navItemActiveBackground,
    navItemActiveColor,
    navItemHoverBackground,
    navItemHoverColor
  } = navbar;

  const styles = StyleSheet.create({
    navItem: {
      height: navbarHeight,
      width: '40px',
      background: navItemBackground,
      color: navItemColor,
      fill: navItemColor,
      ':hover:not(.selected)': {
        background: navItemHoverBackground,
        color: navItemHoverColor,
        fill: navItemHoverColor
      }
    },
    selectedNavItem: {
      background: navItemActiveBackground,
      color: navItemActiveColor,
      borderBottom: `2px solid ${navItemActiveColor}`
    }
  });

  return (
    <li
      ref={ref}
      className={
        `fx fx__hv-center
        ${selected ? 'selected' : ''}
        ${className} ${css(styles.navItem, (props.className.indexOf('selected') >= 0) && styles.selectedNavItem)}`
      }
      style={{ ...style }}
      onClick={() => {
        if (props.onClick) {
          props.onClick();
        } else {
          if (navigate) {
            navigate('/search');
          }
        }
      }}
    >
      {props.children}
    </li>
  );
});

NavItem.propTypes = propTypes;
NavItem.defaultProps = defaultProps;

export { NavItem };
